import Vue from 'vue';
import Vuex from 'vuex';
import { authAPI, subjectAPI } from '../api';

Vue.use(Vuex);

const savedUser = localStorage.getItem('smartstudy_user');

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('smartstudy_token') || '',
    user: savedUser ? JSON.parse(savedUser) : {},
    subjects: [],
    currentSession: null,
    role: localStorage.getItem('smartstudy_role') || 'student'
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      localStorage.setItem('smartstudy_token', token || '');
    },
    SET_USER(state, user) {
      state.user = user || {};
      localStorage.setItem('smartstudy_user', JSON.stringify(state.user));
    },
    SET_SUBJECTS(state, subjects) {
      state.subjects = subjects || [];
    },
    SET_CURRENT_SESSION(state, session) {
      state.currentSession = session;
    },
    SET_ROLE(state, role) {
      state.role = role;
      localStorage.setItem('smartstudy_role', role);
    },
    CLEAR_AUTH(state) {
      state.token = '';
      state.user = {};
      state.currentSession = null;
      state.role = 'student';
      localStorage.removeItem('smartstudy_token');
      localStorage.removeItem('smartstudy_user');
      localStorage.removeItem('smartstudy_role');
    }
  },
  actions: {
    async login({ commit }, credentials) {
      const res = await authAPI.login(credentials);
      commit('SET_TOKEN', res.data.token);
      commit('SET_USER', res.data.user);
      commit('SET_ROLE', 'student');
      return res;
    },
    async parentLogin({ commit }, credentials) {
      // 家长登录使用同样的API，但标记为家长身份
      const res = await authAPI.login(credentials);
      commit('SET_TOKEN', res.data.token);
      commit('SET_USER', res.data.user);
      commit('SET_ROLE', 'parent');
      return res;
    },
    async register({ commit }, payload) {
      const res = await authAPI.register(payload);
      commit('SET_TOKEN', res.data.token);
      commit('SET_USER', res.data.user);
      commit('SET_ROLE', 'student');
      return res;
    },
    async fetchUser({ commit }) {
      const res = await authAPI.getProfile();
      commit('SET_USER', res.data);
      return res;
    },
    async fetchSubjects({ commit }) {
      const res = await subjectAPI.getList();
      commit('SET_SUBJECTS', res.data);
      return res;
    },
    async logout({ commit }) {
      commit('CLEAR_AUTH');
    }
  }
});